import React from 'react'
import { ReactComponent as SoldCarIcon } from '../../../images/sold_vehicle_path/sold_car.svg'
import { ReactComponent as EmailIcon } from '../../../images/icons/email_icon.svg'
import { ReactComponent as NameIcon } from '../../../images/icons/click_to_chat_icon.svg'
import { ReactComponent as PhoneIcon } from '../../../images/icons/phone_icon.svg'
import dayjs from 'dayjs'

type SaleStepProps = {
  date: Date
  name?: string
  email?: string
  phone?: string
}

export default function SaleStep({ path }: { path: SaleStepProps }): JSX.Element {
  return (
    <div
      className={
        'py-3 px-4 rounded-2xl flex-col gap-2 min-w-60 h-80 flex border-2 bg-[#0DBDE3]/20 border-primary-persian-blue'
      }>
      <div className={'flex w-full items-center flex-col gap-2'}>
        <SoldCarIcon />
        <div className={'mx-auto text-center'}>
          <h3 className={'font-bold text-md text-primary-persian-blue uppercase'}>
            Sold Car!
          </h3>
          <h4 className={'font-regular text-xs text-primary-persian-blue font-medium'}>
            {dayjs(path?.date).format('MMM D, YYYY - HH:mm:ss')}
          </h4>
        </div>
      </div>
      {path.name && (
        <div className="border-t-2 border-primary-persian-blue/20 pt-2 flex flex-col gap-6">
          <div className="flex flex-row gap-3 items-center">
            <NameIcon />
            <div className="flex flex-col gap-1 text-primary-persian-blue">
              <span className="font-bold text-sm uppercase">Name</span>
              <span className="font-semibold text-xs">{path.name}</span>
            </div>
          </div>
        </div>
      )}
      {path.email && (
        <div className="border-t-2 border-primary-persian-blue/20 pt-2 flex flex-col gap-6">
          <div className="flex flex-row gap-3 items-center">
            <EmailIcon />
            <div className="flex flex-col gap-1 text-primary-persian-blue">
              <span className="font-bold text-sm uppercase">Email</span>
              <span className="font-semibold text-xs">{path.email}</span>
            </div>
          </div>
        </div>
      )}
      {path.phone && (
        <div className="border-t-2 border-primary-persian-blue/20 pt-2 flex flex-col gap-6">
          <div className="flex flex-row gap-3 items-center">
            <PhoneIcon />
            <div className="flex flex-col gap-1 text-primary-persian-blue">
              <span className="font-bold text-sm uppercase">Phone</span>
              <span className="font-semibold text-xs">{path.phone}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
